import {
  Box,
  Button,
  Card,
  Center,
  Divuuider,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addITskillAsync,
  deleteITskillAsync,
  fetchITskillsAsync,
  selectITskills,
  updateITskillAsync,
} from "./LanguageSlice";
import { useForm } from "react-hook-form";
import {
  fetchJobSkillsAsync,
  selectJobSkills,
} from "../../../AdminPanel/JobPostingSlice/JobSkillsList/JobSkillsSlice";
import SpinnerLoad from "../../../common/Spinner";
import nodata from "../../../candidateDashboard/components/nodata1.png";
import Language from "../../components/Language";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "@chakra-ui/icons";

function Languages() {
  return (
    <div className="">
      <Language />
        <div className="w-full flex flex-wrap justify-center gap-2 mt-5">
          <Box textAlign="center" mt={4} width={{ base: "full", md: "auto" }}>
            <Link to="/candidate-dashboard">
              <Button
                width={{
                  base: "full",
                  sm: "md",
                  md: "lg",
                  lg: "xl",
                  xl: "4xl",
                }}
                rightIcon={<ArrowRightIcon />}
                colorScheme="blue"
              >
                Next
              </Button>
            </Link>
          </Box>
      </div>
    </div>
  );
}

export default Languages;
